<template>
  <CardGroup>
    <div class="forcast-overview">
      <sdCards :title="$t('pages.home.overview')">
        <template #button>
          <div class="card-radio">
            <a-radio-group @change="forcastOverview" v-model:value="selectedDate">
              <a-radio-button value="today">{{$t('pages.home.today')}}</a-radio-button>
              <a-radio-button value="week">{{$t('pages.home.week')}}</a-radio-button>
              <a-radio-button value="month">{{$t('pages.home.month')}}</a-radio-button>
              <a-radio-button value="year">{{$t('pages.home.year')}}</a-radio-button>
            </a-radio-group>
          </div>
        </template>

        <div v-if="foIsLoading" class="sd-spin">
          <a-spin />
        </div>

        <a-row v-else :gutter="25">
          <a-col :xl="12" :md="24">
            <a-row class="focard-wrapper focard-divider">
              <a-col :md="12" :sm="12" :xs="24">
                <Focard>
                  <div class="focard-details growth-upward">
                    <sdHeading as="h1">{{ dashboardOverviewData.order }} ₺</sdHeading>
                    <p class="subtitle">{{$t('pages.home.total-sales')}}</p>
                    <p class="focard-status">
                      <span class="focard-status__percentage">
                        <sdFeatherIcons type="trending-up" />
                        25%
                      </span>
                      <span> 20,641 (prev)</span>
                    </p>
                  </div>
                </Focard>
              </a-col>
              <a-col :md="12" :sm="12" :xs="24">
                <Focard>
                  <div class="focard-details growth-upward">
                    <sdHeading as="h1">{{ dashboardOverviewData.member }}</sdHeading>
                    <p class="subtitle">{{$t('pages.home.total-member')}}</p>
                    <p class="focard-status">
                      <span class="focard-status__percentage">
                        <sdFeatherIcons type="trending-up" />
                        14%
                      </span>
                      <span> 20,641 (prev)</span>
                    </p>
                  </div>
                </Focard>
              </a-col>
            </a-row>
          </a-col>
          <a-col :xl="12" :xs="24">
            <a-row class="focard-wrapper">
              <a-col :md="12" :sm="12">
                <Focard>
                  <div class="focard-details growth-downward">
                    <sdHeading as="h1">{{ dashboardOverviewData.message }}</sdHeading>
                    <p class="subtitle">{{$t('pages.home.total-messages')}}</p>
                    <p class="focard-status">
                      <span class="focard-status__percentage">
                        <sdFeatherIcons type="trending-down" />
                        12%
                      </span>
                      <span> 20,641 (prev)</span>
                    </p>
                  </div>
                </Focard>
              </a-col>
              <a-col :md="12" :sm="12" :xs="24">
                <Focard>
                  <div class="focard-details growth-upward">
                    <sdHeading as="h1">{{ dashboardOverviewData.review }}</sdHeading>
                    <p class="subtitle">{{$t('pages.home.total-review')}}</p>
                    <p class="focard-status">
                      <span class="focard-status__percentage">
                        <sdFeatherIcons type="trending-up" />
                        14%
                      </span>
                      <span> 20,641 (prev)</span>
                    </p>
                  </div>
                </Focard>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </sdCards>
    </div>
  </CardGroup>
</template>

<script>
import { Focard, CardGroup } from '../style';
import Chart from '../../../components/utilities/chartjs';

export default {
  name: 'OverviewCard',
  components: {
    Focard,
    CardGroup,
    Chart,
  },
  data() {
    return {
      foIsLoading: true,
      selectedDate: 'today',
      statistics: ['member', 'message', 'review', 'order'],
      dashboardOverviewData: {
        member: 0,
        order: 0,
        message: 0,
        review: 0,
      },
    };
  },
  methods: {
    forcastOverview() {
      this.statistics.forEach(e => this.getData(e, this.selectedDate));
    },
    getData(type, date = 'today') {
      this.foIsLoading = true;
      this.$appAxios.post(this.$endpoints.dashboard_statistics + '/' + type + '/summary/' + date)
        .then(response => {
          if (response.data.status === true) {
            switch (type) {
              case 'member':
                this.dashboardOverviewData.member = response.data.data.total_record;
                break;
              case 'message':
                this.dashboardOverviewData.message = response.data.data.total_record;
                break;
              case 'review':
                this.dashboardOverviewData.review = response.data.data.total_record;
                break;
              case 'order':
                this.dashboardOverviewData.order = response.data.data.total_amount;
                break;
            }
          }
          this.foIsLoading = false;
        })
        .catch(e => {
        });
    },
  },
  created() {
    this.statistics.forEach(e => this.getData(e));
  },
};
</script>
